import api from './api';

const notificationAPI = {
  // Get notifications for current user
  getNotifications: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.unread !== undefined) {
      queryParams.append('unread', params.unread);
    }
    if (params.type) {
      queryParams.append('type', params.type);
    }
    if (params.page !== undefined) {
      queryParams.append('page', params.page);
    }
    if (params.size !== undefined) {
      queryParams.append('size', params.size);
    }

    const response = await api.get(`/notifications?${queryParams.toString()}`);
    return response.data;
  },

  // Get unread count
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    const response = await api.post(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // Mark all notifications as read
  markAllAsRead: async () => {
    const response = await api.post('/notifications/mark-all-read');
    return response.data;
  },

  // Get notification details
  getNotification: async (notificationId) => {
    const response = await api.get(`/notifications/${notificationId}`);
    return response.data;
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  }
};

export default notificationAPI;

